import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";

type Props = {
	value: string;
	onChange: (value: string) => void;
};

export const TextFieldSearchFilter = ({ value, onChange }: Props) => {
	return (
		<TextField
			label="Search"
			value={value}
			size="small"
			fullWidth
			onChange={(event) => {
				onChange(event?.target.value);
			}}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon fontSize="small" />
						</InputAdornment>
					),
				},
			}}
			sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
		/>
	);
};
